import React from 'react';

const HouseNames = ({ loading }) => {
    return loading ? (   //Checkif if is loading
    <div class="loader-wrapper"><div class="loader"></div></div>
    ) : ""

}

export default HouseNames